// SportsbookHorizontalScrollArea.tsx
import { HorizontalScrollArea } from '@comeon/ui';
import styled from 'styled-components';
import Icon, { ICON_LEFT, ICON_RIGHT } from '~/components/icon';

const StyledScrollAreaButton = styled(HorizontalScrollArea.Button)`
	border-radius: unset;
	background-color: unset;
	opacity: 0;
	transition: all 0.2s ease-in;
	color: var(--main-action-icons);
`;

const StyledScrollAreaRoot = styled(HorizontalScrollArea.Root)`
	width: unset;

	&:hover ${StyledScrollAreaButton} {
		opacity: 1;
	}
`;

const StyledHScrollAreaView = styled(HorizontalScrollArea.View)`
	overflow-y: visible;
	gap: 10px;
`;

// Compound re-exports
const SportsbookHorizontalScrollArea = {
	Root: ({ children, ...props }: React.ComponentProps<typeof StyledScrollAreaRoot>) => (
		<StyledScrollAreaRoot {...props} scrollDistance={viewRef => (viewRef.current?.clientWidth || 0) * 0.95}>
			{children}
		</StyledScrollAreaRoot>
	),
	View: StyledHScrollAreaView,
	LeftButton: ({
		icon = <Icon type={ICON_LEFT} />,
		...props
	}: Omit<React.ComponentProps<typeof StyledScrollAreaButton>, 'direction' | 'icon'> & {
		icon?: React.ReactNode;
	}) => <StyledScrollAreaButton direction="left" icon={icon} {...props} />,
	RightButton: ({
		icon = <Icon type={ICON_RIGHT} />,
		...props
	}: Omit<React.ComponentProps<typeof StyledScrollAreaButton>, 'direction' | 'icon'> & {
		icon?: React.ReactNode;
	}) => <StyledScrollAreaButton direction="right" icon={icon} {...props} />
};

export default SportsbookHorizontalScrollArea;
